
import { toggleEvent, createEvent, getEvent, updateEvent, listDataEvent, deleteEvent, listDataPick, createPick } from '@/zsm-api-new/event.js'
import { Message } from 'element-ui';
import { accSub, formatDate } from "@/utils/index";
const state = {
  // 优惠券表单内容
  eventInfo: {
    showGiveFlag: 0,//详情是否展示赠品
    status: 9,
    eventDict: 101,// 促销类型  101=固定时间促销活动，201=优惠券 301 = 买赠套餐 2012 = 分享券 2013 = 直播券
    goodId: '', // 商品
    originPrice: '', // 原价
    eventPrice: '', // 实际价格
    subtractPrice: '', //  促销金额
    startTime: '', // 开始日期
    endTime: '', // 截止日期
    openFlag: '0', // 手动开启或关闭促销活动  0=关闭  1=开启
    stockFlag: '0', // 是否有库存限制。0=无限制，1=有限制
    cover: '', // 活动或优惠券的封面
    stockCount: '', // 限制数量
    title: '', // 活动标题或优惠券名称
    timeDict: '0', // 优惠券有效期类型   0=与活动时间一致，1=自定义时间（此时下面三个字段才有意义）
    timeDay: 0, // timeDict=1时，这里代表天数量
    timeHour: 0, // timeDict=1时，这里代表小时数量
    timeMin: 0 // timeDict=1时，这里代表分钟数量
  }, // 优惠券内容
}

const mutations = {
  /**
   * 校验优惠券创建是否合规
   * @param {*} info 
   * @returns 
   */
  validCoupon(info) {
    if (!info.eventDict == '301' && info.title == '') {
      Message.error('请输入活动名称')
      return
    }
    if (info.eventDict == '301' && info.giveGoodId == '') {
      Message.error('请选择主课程')
      return
    }
    if (info.eventDict == '301' && info.giveGoodList.length == 0) {
      Message.error('请添加赠送课程')
      return
    }
    if ((info.eventDict == '201' || info.eventDict == '401') && info.subtractPrice == '') {
      Message.error('请输入抵消金额')
      return
    }
    if (info.eventDict == '101' && info.eventPrice == '') {
      Message.error('请输入活动价格')
      return
    }
    if (info.courseInfo.price <= info.subtractPrice) {
      Message.error('抵扣金额需小于课程原价~')
      return
    }
    if (!info.startTime || !info.endTime) {
      Message.error('请输入活动日期')
      return
    }
    if (info.goodId == '') {
      Message.error('请选择关联课程')
      return
    }
    if (info.stockFlag == 1 && (!info.stockCount)) {
      Message.error('请输入优惠券数量')
      return
    }
    if (info.timeDict == 1 && info.timeDay == '' && info.timeHour == '' && info.timeMin == '') {
      Message.error('请输入优惠券有效期')
      return
    }
    return info
  }
}

const actions = {


  /**
  * 新创建或修改促销活动
  * @return
  */
  createEvent2({ commit }, info) {
    let courseInfo = info.courseInfo;
    info.goodId = courseInfo.id// 课程id
    info.cover = courseInfo.cover// 课程id
    info.goodName = courseInfo.title// 课程标题
    if ((info.eventDict == '101' || info.eventDict == '301')) {
      info.subtractPrice = accSub(courseInfo.price, info.eventPrice)// 活动金额
    } else if ((info.eventDict == '201' || info.eventDict == '2012')) {
      info.eventPrice = accSub(courseInfo.price, info.subtractPrice)// 折扣金额
    } else {
      if ((info.eventDict == '101' || info.eventDict == '301')) {
        info.subtractPrice = accSub(courseInfo.price, info.eventPrice)// 活动金额
      }
    }
    info.originPrice = courseInfo.price
    // 课程信息
    if (!mutations.validCoupon(info)) {
      return
    }
    delete info.courseInfo;
    if (info.timeDay == '') {
      info.timeDay = 0
    }
    if (info.timeHour == '') {
      info.timeHour = 0
    }
    if (info.timeMin == '') {
      info.timeMin = 0
    }
    if (info.timeDict == 0) {
      info.timeDay = 0 // timeDict=1时，这里代表天数量
      info.timeHour = 0 // timeDict=1时，这里代表小时数量
      info.timeMin = 0 // timeDict=1时，这里代表分钟数量
    }
    info.mobile = JSON.parse(JSON.parse(this.state['zsm-user'].userInfo)).mobile;
    info.loginCode = JSON.parse(JSON.parse(this.state['zsm-user'].userInfo)).mobile;
    info.platformDict = this.state['zsm-user'].platformDict;
    info.originPrice = courseInfo.price// 课程id
    info.startTime = formatDate(info.startTime).timeStrB;// 课程id
    info.endTime = formatDate(info.endTime).timeStrB// 课程id
    // 买赠逻辑
    if (info.giveGoodList) {
      let giveGoodId = [];//商品ID
      let giveGoodName = [];//商品名称
      info.giveGoodList.map((item) => {
        giveGoodId.push(item.id)
        giveGoodName.push(item.title)
      })
      info.giveGoodId = giveGoodId.join(',');
      info.giveGoodName = giveGoodName.join(',');
    }

    return new Promise((resolve, reject) => {
      if (info.id) {
        updateEvent(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      } else {
        createEvent(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      }

    })
  },

  // 开启或关闭活动
  toggleEvent({ commit }, info) {
    return new Promise((resolve, reject) => {
      toggleEvent(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 领取优惠券
  createPick({ commit }, info) {
    return new Promise((resolve, reject) => {
      createPick(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 领取的优惠券列表
  listDataPick({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataPick(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 删除优惠券
  deleteEvent({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteEvent(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取优惠券
  getEvent({ commit }, id) {
    return new Promise((resolve, reject) => {
      getEvent(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 编辑优惠券
  updateEvent({ commit }, info) {
    return new Promise((resolve, reject) => {
      if (info.eventPrice <= 1) {
        Message.error(`课程定价不可低于1元、以及活动、优惠、团购后的价格）`)
        reject(false)
        return
      };
      updateEvent(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 优惠券列表
  listDataEvent({ commit }, info) {
    info = {
      ...info,
      platformDict: this.state['zsm-user'].platformDict,
      loginCode: JSON.parse(JSON.parse(this.state['zsm-user'].userInfo)).mobile
    }
    return new Promise((resolve, reject) => {
      listDataEvent(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建优惠券
  createEvent({ commit }, info) {
    return new Promise((resolve, reject) => {
      if (info.eventPrice <= 1) {
        Message.error(`课程定价不可低于1元、以及活动、优惠、团购后的价格）`)
        reject(false)
        return
      };
      createEvent(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
